export function toStoneBrand (text) {
  if (!text) return text
  return text.replace(/pagar\.?me/gi, 'Stone')
}
